import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { IHotel, IRoomType } from "../../../models/BaseModel";
import { Fetch } from "../../../shared/Fetch";
import { Search } from "../../../shared/Search";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { RoomTypeForm } from "./RoomTypeForm";
import { IOpenForm } from "../Hotel";
import { RoomTypeAminites } from "./RoomTypeAminities";

interface Iprops {
    open: boolean,
    hideDialog: () => void,
    hotel: IHotel,
    toast: any
}

export const RoomTypeTable = (props: Iprops) => {
    const [tableData, setTableData] = useState({ data: [], loading: false } as { data: IRoomType[], loading: boolean });
    const [modal, setModal] = useState<{ roomtype: IRoomType, open: boolean }>({ roomtype: {}, open: false });
    const [openAmenties, setOpenAmenties] = useState({ singleData: {}, open: false } as any);

    useEffect(() => {
        if (props.hotel.id) loadTableData(props.hotel.id);
    }, [props.hotel.id]);

    const loadTableData = async (hotelId: number) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`roomtype/${hotelId}`, "GET", null, null, props.toast);
        if (response) {
            const roomTypes: IRoomType[] = await response.json();
            setTableData({ data: roomTypes, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        setModal({ roomtype: { hotelId: props.hotel.id, isActive: true }, open: true });
    };

    const openEdit = (r: IRoomType) => {
        setModal({ roomtype: { ...r }, open: true });
    };

    const onRoomTypeAddOrUpdateSuccess = () => {
        if (props.hotel.id) loadTableData(props.hotel.id);
        setModal({ roomtype: {}, open: false });
    }
    const onClose = () => {
        setModal({ roomtype: {}, open: false });
    }

    const Remove = async (rowData: IRoomType) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`roomtype/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Room Type Deleted", life: 3000 });
            if (props.hotel.id) loadTableData(props.hotel.id);
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IRoomType) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }


    const openEditAmenties = (rowData: any) => {
        setOpenAmenties({ open: true, singleData: rowData });
    };

    const actionBodyTemplate = (rowData: IRoomType) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />
                <Button icon="pi pi-box" tooltip="Aminities" tooltipOptions={{ position: "top" }} className='p-button-info p-button-text p-0' onClick={() => { openEditAmenties(rowData) }}  ></Button>
                <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }}  ></Button>

            </div>
        );
    };

    const statusBody = (rowData: IRoomType) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.isActive ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isActive ? '#4caf50' : '#f44336' }}></i>
                <span>{rowData.isActive ? 'Active' : 'Disable'}</span>
            </div>
        );
    }

    if (!props.open) return null;

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4"
            style={{
                background: "linear-gradient(90deg, #def7e3ff, #ecf4edff)",
                borderBottom: "2px solid #95e99c",
                borderRadius: "8px 8px 0 0",
                padding: "0.6rem 1rem",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)"
            }}
        >
            <div className="flex gap-4 w-full">
                <Button style={{ width: '80px', height: '30px' }} loading={tableData.loading} onClick={openNew} label="New" icon="pi pi-plus"
                    type="button"
                    className="p-button-sm p-button-rounded p-button-success mb-2"
                />
                <div className="w-full flex align-items-center justify-content-center">
                    <h5 style={{ margin: 0, color: "#00796b" }}>
                        Room Types : {props.hotel.name}
                    </h5>
                </div>
            </div>
            <div className="flex gap-4">

            </div>
        </div>
    );

    const hideroomAmenties = () => {
        setOpenAmenties({ open: false, singleData: {} })
    }

    return (
        <>
            <div
                style={{
                    backgroundColor: "#f6fdf8", // soft greenish background
                    border: "1px solid #cce3d0",
                    borderRadius: "14px",
                    padding: "1rem",
                    margin: "1rem 0.5rem",
                    boxShadow: "0 3px 10px rgba(0, 128, 0, 0.08)", // subtle greenish shadow
                    transition: "all 0.3s ease-in-out",
                }}
                className="expand-container"
            >
                {/* {modal.open ? <RoomTypeForm onSuccess={onRoomTypeAddOrUpdateSuccess} onClose={onClose} singleData={modal.roomtype} toast={props.toast} /> :
                <Button style={{ width: '80px', height: '30px' }} loading={tableData.loading} onClick={openNew} label="New" icon="pi pi-plus" type="button" className="p-button-sm p-button-rounded p-button-success mb-2"></Button>} */}
                <DataTable className="grey-teal-table" value={tableData.data} loading={tableData.loading} header={header} style={{
                    background: "white",
                    borderRadius: "10px",
                    overflow: "hidden",
                }}
                    size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh"
                    rowClassName={(d: IRoomType) => (d.id === modal.roomtype.id ? 'bg-orange-100' : 'bg-teal-50')}>
                    <Column field="name" header="Room Type" sortable />
                    <Column field="capacity" header="Occupancy" sortable />
                    {/* <Column field="price" header="Price/Day" sortable /> */}
                    {/* <Column field="bedTypeName" header="BedType" sortable /> */}
                    <Column field="mattress" header="Extra Matt" body={(r: IRoomType) => r.mattress ? r.mattress : 'N/A'} />
                    <Column field="mattressPrice" header="Matt Price/Day" body={(r: IRoomType) => r.mattress ? r.mattressPrice : 'N/A'} />
                    <Column field="availableRooms" header="Rooms" sortable />
                    <Column field="isActive" header="Status" sortable body={statusBody} />
                    <Column field="desc" header="Desc" />
                    <Column body={actionBodyTemplate} />
                </DataTable>
                <Dialog header={modal.roomtype.id ? 'Update Room Type' : 'Add Room Type'} visible={modal.open} style={{ width: '600px' }} modal onHide={onClose}>
                    <RoomTypeForm onSuccess={onRoomTypeAddOrUpdateSuccess} onClose={onClose} singleData={modal.roomtype} toast={props.toast} />
                </Dialog>
                <RoomTypeAminites hotel={openAmenties.singleData} open={openAmenties.open} hideDialog={hideroomAmenties} toast={props.toast} />
            </div>
        </>
    );
}
